export const environment = {
    api: {
        domain: 'wbce.ovh.webcapsule.io',
        protocol: 'https',
        port: undefined,
    },
    keycloak: {
        domain: 'keycloak.ovh.webcapsule.io',
        protocol: 'https',
        port: undefined,
    },
    production: true,
    mock: false,
    directusOnly: false,
    googleTagID: '',
    datadog: undefined,
};
